@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.float-currency-input {
  position: relative;
  padding: 0;
  transition: all 300ms ease;
  background: @float-currency-input--background-color;
  border-radius: 4px;
  border: 1px solid @float-currency-input--border-color;
  height: 42px;
  &.focused {
    border-color: @float-currency-input--focused--border-color;
  }
  &.disabled {
    border-color: @float-currency-input--border-color;
  }
  &.error {
    border: solid 1px @float-currency-input--error--border-color;
  }
}

.input-container {
  display: flex;
  top: 10px;
  position: absolute;
  opacity: 0;
  transition: all 300ms ease;
  align-items: center;
  font-size: 14px;
  input {
    border: 0;
    resize: none;
    background: transparent;
    padding: 0 0 0 5px;
    color: @float-currency-input--text-color;
    line-height: 20px;
    font-size: 14px;
    width: 90%;
  }
  input:focus {
    outline: none;
  }

  input:disabled {
    background: transparent;
  }

  &.symbol-right {
    flex-direction: row-reverse;
    input {
      padding-left: 10px;
    }
    .currency {
      padding-left: 0;
    }
  }
  &.shown {
    opacity: 1;
  }
  &.error {
    input {
      color: @float-currency-input--error--text-color;
    }
  }
}

.currency {
  color: @float-currency-input--currency--text-color;
  padding-left: 10px;
  padding-top: 2px;
}

.required-indicator {
  position: absolute;
  top: 0;
  right: 0;
}
